import React from 'react';

function PersonCancel({ color = '#335B70', ...props }) {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
            <path
                d="M13.05 9.75 12 8.7l1.556-1.575L12 5.569 13.05 4.5l1.575 1.575L16.181 4.5l1.069 1.069-1.575 1.556L17.25 8.7l-1.069 1.05-1.556-1.556zM4.631 8.119A2.9 2.9 0 0 1 3.75 6q0-1.237.881-2.119A2.9 2.9 0 0 1 6.75 3q1.237 0 2.119.881.88.882.881 2.119 0 1.237-.881 2.119A2.9 2.9 0 0 1 6.75 9a2.9 2.9 0 0 1-2.119-.881M.75 15v-2.1q0-.638.328-1.172.329-.534.872-.816a11 11 0 0 1 2.363-.871q1.2-.291 2.437-.291t2.438.29 2.362.873q.543.28.872.815t.328 1.172V15zm1.5-1.5h9v-.6a.73.73 0 0 0-.375-.638 9.8 9.8 0 0 0-2.044-.759 8.7 8.7 0 0 0-4.162 0 9.8 9.8 0 0 0-2.044.76.73.73 0 0 0-.375.637zm5.56-6.44q.44-.44.44-1.06 0-.618-.44-1.06a1.44 1.44 0 0 0-1.06-.44q-.619 0-1.06.44-.44.442-.44 1.06t.44 1.06q.442.44 1.06.44t1.06-.44"
                fill={color}
            />
        </svg>
    );
}

export default PersonCancel;
